<!-- https://github.com/picturepan2/devices.css -->
<div
  [ngClass]="{
    'device-has-content': hasContent
  }"
>
  <dentr-devices-iphone-14-pro *ngIf="device === DEVICES.IPHONE_14_PRO">
    <ng-container *ngTemplateOutlet="tmpl"></ng-container>
  </dentr-devices-iphone-14-pro>
  <div class="mt-4 rounded-3xl bg-white p-4 shadow-lg" *ngIf="hasDebugInfo">
    <h2 class="heading-lg mb-3 flex items-center">
      Debug info
      <ng-icon name="heroBugAnt" size="18" class="ml-1"></ng-icon>
    </h2>
    <div *ngIf="hasDebugInfo">
      @for (item of debugInfo | keyvalue; track item) {
      <div class="flex flex-row gap-2">
        <span class="heading-sm">{{ item.key }}:</span>
        <span>{{ item.value }}</span>
      </div>
      }
    </div>
  </div>
</div>

<ng-template #tmpl>
  <div #content class="h-full">
    <video poster="assets/devices/{{ video.poster }}" autoplay loop muted class="device-content-placeholder" *ngIf="(!hasContent || showVideo) && video.src">
      <source src="assets/devices/{{ video.src }}" type="video/{{ video.type }}" />
    </video>
    <div class="device-content">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
